/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import CustomSearch from '@reedexpo/custom-search';
import sortBy from 'lodash/sortBy';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import Algolia from './AlgoliaSearchWrapper';
import Tags from '../../common/dtmTags';
import TranslationService from '../../translations';
import {
  CountryFilters,
  Filters,
  OrganisationGuidFacet,
  PPSSortOrder,
  Packages,
} from '../../common/Constants';
import { defaultArtistLogoUrl, defaultOrganisationListingLogoUrl } from '../../../images/assets.json';
import ErrorContainer from '../../common/components/ErrorContainer';
import algoliaService from './algoliaService';
import {
  getFilterQueries,
  isCheckedLeaf,
  markSelectedItems,
  parseFilterJson,
  parseQuestion,
  populateLabel,
  refineFiltersFromQueryString,
  refineSearchState,
  sanitizeLabel,
  searchStateToUrl,
  updateUrlWIthFilterRefinements,
  getNoOfSlotsAllocated
} from './Utils';
import Utils, {
  appendQueryParam,
  constructQueryParamWithExistingQueryParams,
  getQueryParamValue,
  isParticipantBase,
  removeQueryParam
} from '../../common/Utils';
import Products from '../../productDirectory/Products';
import Producer from '../../producerDirectory/Producer';
import ExhibitorDirectoryListView from '../packages/ExhibitorDirectoryListView';
import AlgoliaMapper from '../../common/exhibitingOrganisation/AlgoliaMapper';
import ExhibitorDirectoryGridView from '../packages/ExhibitorDirectoryGridView';
import ExhibitorDetailService from '../../exhibitorHub/api/ExhibitorDetailService';
import authorizationStore from '../../common/api/authorizationStore';

import DiscoverProducts from '../../productDirectory/DiscoverProducts';
import DiscoverService from '../DiscoverService';
import EventEditionFeatureConfigService from '../../profile/api/EventEdititonFeatureConfigService';
import EventEditionService from '../../common/api/EventEditionService';
import Logger from '../../logger';
import BigCircleSpinner from '../../common/components/BigCircleSpinner';
import {Mutex} from 'async-mutex';
import mixpanelConstants from '../../common/mixpanelConstants';
import MixpanelHelper from '../../common/MixpanelHelper';

let logger;
const paginationQueryParam = 'page';

const generateAlgoliaFilterQuery = (query, isExhibitor, networkFollowees) => {
  const keys = Object.keys(query);
  const filterQueryGroup = [];
  const existingLeafSelections = [];
  keys.forEach((key) => {
    const queryGroup = groupBy(query[key], q => q.queryKey);
    const queryGroupKeys = Object.keys(queryGroup);
    queryGroupKeys.forEach((k) => {
      let filterQuery = [];
      queryGroup[k].forEach((q) => {
        if (queryGroupKeys.length === 1 && queryGroupKeys[0] === OrganisationGuidFacet.organisationGuid) {
          networkFollowees.forEach((org) => {
            filterQuery.push(`${q.queryKey}:${org}`);
          });
        }
        filterQuery.push(`${q.queryKey}:${q.queryText}`);
        if (isExhibitor && isCheckedLeaf(q)) {
          const currentLeafSelection = `sponsoredCategory.id:${q.queryText.split(':')[0]}`;
          filterQueryGroup.forEach(a => a.push(currentLeafSelection));
          filterQueryGroup.forEach((arr) => {
            return existingLeafSelections.concat(arr.filter((v => v.includes('sponsoredCategory.id'))));
          });
          existingLeafSelections.push(currentLeafSelection);
        }
        filterQuery = [...existingLeafSelections, ...filterQuery];
      });
      filterQueryGroup.push(filterQuery);
    });
  });
  return filterQueryGroup;
};

const getAlgoliaFilterQuery = (filterData, config, isExhibitor) => {
  const query = getFilterQueries(filterData, config);
  return generateAlgoliaFilterQuery(query, isExhibitor, config.networkFollowees);
};

class AlgoliaWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      label: 'shortDescription',
      id: 'Id',
      nestedKey: 'answers',
      hasMore: true,
      pageStart: this.getPageNumber(),
      resetPage: 0,
      filterQuery: '',
      hits: [],
      prioritySlotsPremiumExhibitors: [],
      searchState: refineSearchState(window.location.search.slice(1)),
      hasError: false,
      total: 0,
      sortOptions: null,
      sortValue: null,
      networkFollowees: [null],
      digitalPortfolioId: '',
      isNetworkParticipant: false,
      discoverProducts: [],
      discoverTotal: 0,
      discoverFilters: [],
      hideStandInfo: false,
      showExhibitorRecommendation: false,
      isMercuryParticipantShow: false,
      indexName: props.indexName,
      displayLoader: false
    };
    const {appId, apiKey} = this.props;
    this.client = Algolia.search(appId, apiKey);
    logger = Logger.getLogger();
    this.mutex = new Mutex();
  }

  componentDidMount() {
    const {
      appId, apiKey, context, baseApiUrl
    } = this.props;
    const algoliaConfig = {
      appId, apiKey
    };

    if (this.showNetworkingFacet(context)) {
      EventEditionService.getEventEditionById(baseApiUrl, context.eventEditionId)
        .then(serviceResult => {
          Utils.saveToSessionStorage('isParticipationEvent', serviceResult.body?.data?.eventEdition?.isParticipationEvent);
          const isMercuryParticipantShow = serviceResult.body?.data?.eventEdition?.isAnonymousRegistrationEnabled && serviceResult.body?.data?.eventEdition?.isParticipationEvent;
          this.setState({isMercuryParticipantShow: isMercuryParticipantShow});
        });

    }

    if (!this.isExhibitorDirectory()) {
      const sortOptionsTranslation = TranslationService.getTranslations(context.interfaceLocale).productDirectory.sortOptions;
      this.client.initIndex(this.state.indexName)
        .getSettings().then((settings) => {
          this.setSortOptions(settings.replicas, sortOptionsTranslation, this.state.indexName);
          this.setAlgoliaIndexFromUrlSortOption(settings.replicas);
        });
    }

    if (window.location.search.slice(1).includes('refinementList')) {
      algoliaService.getFilterData(algoliaConfig, this.state.indexName, this.getRecordTypeAndLocaleFilter()).then((result) => {
        this.setState({ filterQuery: refineFiltersFromQueryString(window.location.search.slice(1), result.facets) }, () => this.loadItems(0));
      }).catch((error) => {
        Logger.logWarnWithEvent('Error While Getting FilterData from algolia', error.stack, { indexName: this.state.indexName })
        this.setState({
          hasError: true
        });
      });
    }

    EventEditionFeatureConfigService.getAlgoliaWrapperFeatureToggles(baseApiUrl, context.eventEditionId, context.interfaceLocale)
      .then((featureToggles) => {
        this.setState({
          hideStandInfo: featureToggles.hideStandInfo,
          showExhibitorRecommendation: featureToggles.showExhibitorRecommendation,
        })
      })

    if (this.isExhibitorDirectory()) {
      this.loadNetworkFollowees(baseApiUrl, context.interfaceLocale, context.eventEditionId);
      window.addEventListener('pageshow', this.handlePageLoadedFromCache);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handlePageLoadedFromCache);
  }

  // Refresh followees when the page is restored from the back/forward cache (e.g. back from the details page).
  handlePageLoadedFromCache = (event) => {
    if (event.persisted) {
      const { baseApiUrl, context } = this.props;
      this.loadNetworkFollowees(baseApiUrl, context.interfaceLocale, context.eventEditionId);
    }
  }

  loadNetworkFollowees = (baseApiUrl, interfaceLocale, eventEditionId) => {
    authorizationStore.getToken().then((token) => {
      if (!token) {
        return;
      }
      ExhibitorDetailService.getDigitalPortfolioWithFollowedOrganisations(baseApiUrl, interfaceLocale, eventEditionId)
        .then((result) => {
          if (!result) {
            return;
          }
          this.setState({
            digitalPortfolioId: result.digitalPortfolioId,
            networkFollowees: result.networkFollowees
          });
        });
    });
  }

  // eslint-disable-next-line react/sort-comp
  index = null;
  client = null;
  primaryIndex = 'productNameAsc';

  showNetworkingFacet = context => isParticipantBase(context.mode, context.tenants);

  getRecordTypeAndLocaleFilter = () => (
    this.isArtist() ? ''
      : `recordType:${this.props.directoryPage} AND locale:${this.props.context.interfaceLocale.toLowerCase()} AND eventEditionId:${this.props.context.eventEditionId}`
  )

  getPageNumber = () => {
    const initialPageNo = -1;
    const pageNo = parseInt(getQueryParamValue(paginationQueryParam));
    if(!pageNo) {
      return initialPageNo;
    }
    return pageNo - 2; // -2 (-1 for the infinite scroll to work properly and -1 for the page number to start from 1 so total -2)
  }

  setSortOptions = (replicas, translation, indexName) => {
    const dtmTags = Tags.productDirectory.sortOptions;
    const options = replicas ? replicas.map((x) => {
      const value = x.split('_').slice(-1)[0];
      return {value: `${indexName}_${value}`, label: translation[value], dtmTag: dtmTags[value]};
    }) : [];
    const defaultValue = {
      value: indexName,
      label: translation[this.primaryIndex],
      dtmTag: dtmTags[this.primaryIndex]
    };
    const sortValueFromUrl = this.getSortValueFromUrl(window.location.search.slice(1));
    const initialValue = !sortValueFromUrl || sortValueFromUrl === 'default' || !replicas.includes(`${indexName}_${sortValueFromUrl}`) ?
      defaultValue : {
        value: `${indexName}_${sortValueFromUrl}`,
        label: translation[sortValueFromUrl],
        dtmTag: dtmTags[sortValueFromUrl]
      };
    this.setState({sortOptions: [defaultValue].concat(options), sortValue: initialValue});
  };

  getSortValueFromUrl = urlQueryString => qs.parse(urlQueryString).sort

  resetPage = () => {
    this.setState({
      resetPage: Utils.generateRandomNumber(),
      hits: [],
      prioritySlotsPremiumExhibitors: [],
      hasMore: true,
      pageStart: -1
    });
  };

  sortOnChange = (selectedValue) => {
    const { indexName } = this.state;
    const newSelectedValue = selectedValue.value === indexName ? indexName : selectedValue.value.split('_').slice(-1)[0];
    const component = this.isExhibitorDirectory() ? mixpanelConstants.component.exhibitorDirectory : mixpanelConstants.component.productDirectory;
    MixpanelHelper.trackMixpanelEvent(mixpanelConstants.eventName.sortOrderSelected, { component: component, sortOption: selectedValue.dtmTag?.split('_').slice(-1)[0] });
    this.updateUrlWithSortValue(newSelectedValue, indexName);
    this.setState(
      {
        sortValue: selectedValue,
        indexName: selectedValue.value
      },
      () => {
        this.resetPage();
      }
    );
  }

  updateUrlWithSortValue = (sortValue, indexName) => {
    const newSortValue = sortValue === indexName ? 'default' : sortValue;
    window.history.replaceState(
      {},
      null,
      `${window.location.pathname}?${qs.stringify(constructQueryParamWithExistingQueryParams(
        'sort',
        newSortValue, this.GetUrlParamsExceptSEOPageParam()
      ))}`
    );
  };

  setAlgoliaIndexFromUrlSortOption = (replicaIndices) => {
    const { indexName } = this.state;
    const sortValueFromUrl = this.getSortValueFromUrl(window.location.search.slice(1));
    const replicaIndexName = `${indexName}_${sortValueFromUrl}`;
    if (!sortValueFromUrl || sortValueFromUrl === 'default') {
      return;
    }
    if (!replicaIndices.includes(replicaIndexName)) {
      this.updateUrlWithSortValue('default', indexName);
      this.resetPage();
      return;
    }
    this.setState({
      indexName: replicaIndexName
    })
    this.resetPage();
  }

  onSearch = (searchInput) => {
    const updatedSearchState = { ...this.state.searchState, locale: this.props.locale, query: searchInput };
    this.setState(
      {
        resetPage: Utils.generateRandomNumber(),
        hits: [],
        prioritySlotsPremiumExhibitors: [],
        hasMore: true,
        searchState: updatedSearchState,
        pageStart: -1
      },
      () => {
        this.onSearchStateChange();
      }
    );
  };

  onSearchStateChange = () => {
    const { searchState } = this.state;
    const search = refineSearchState(searchState);
    this.removePageProp(search);
    this.setState({ searchState: search });
    clearTimeout(this.timeoutRef);
    const timeoutRef = setTimeout(() => {
      window.history.replaceState(searchState, null, searchStateToUrl(search));
    }, 1000);
    this.timeoutRef = timeoutRef;
  };

  removePageProp = (search) => {
    if (search.page) delete search.page;
  }

  GetUrlParamsExceptSEOPageParam = () => {
    let queryString = window.location.search.slice(1);
    if (parseInt(getQueryParamValue(paginationQueryParam))) {
      queryString = removeQueryParam(paginationQueryParam);
    }
    return queryString;
  }

  onFilterUpdate = (data) => {
    const { filterData } = data;

    this.mapFilterData(filterData);
    const filterQuery = getAlgoliaFilterQuery(filterData, this.state, this.isExhibitorDirectory());
    updateUrlWIthFilterRefinements(filterQuery, this.GetUrlParamsExceptSEOPageParam());
    this.setState({
      resetPage: Utils.generateRandomNumber(),
      hits: [],
      prioritySlotsPremiumExhibitors: [],
      hasMore: true,
      filterQuery,
      displayLoader: true,
      pageStart: -1
    });
  };

  addAlgoliaFilters = (request) => {
    request['filters'] = this.isArtist() ? '' : `recordType:${this.props.directoryPage} AND locale:${this.props.context.interfaceLocale.toLowerCase()} AND eventEditionId:${this.props.context.eventEditionId}`
  }
  arePremiumSlotsEnabled = () => {
    const sortValueFromUrl = this.getSortValueFromUrl(window.location.search.slice(1));
    const lastUpdatedAtDesc = 'lastUpdatedAtDesc';
    return (this.isExhibitorDirectory() || (this.isProductDirectory() && sortValueFromUrl !== lastUpdatedAtDesc))
  }
  loadItems = async (pageNo) => {
    if (window.location.search.slice(1).includes('refinementList') && !this.state.filterQuery) {
      return;
    }
    if (window.location.search.slice(1).includes('sort') && !this.state.sortValue && !window.location.search.slice(1).includes('default')) {
      return;
    }
    const { query, search } = this.state.searchState;
    const { appId, apiKey, context } = this.props;
    const { indexName } = this.state;
    const algoliaConfig = {
      appId,
      apiKey
    };
    const request = {
      page: pageNo,
      query,
      facetFilters: this.state.filterQuery,
      restrictSearchableAttributes: search
    };
    this.addAlgoliaFilters(request);
    this.setState({ hasMore: false });

    try {
      this.mutex.cancel();
      await this.mutex.runExclusive(async () => {
        if (pageNo === 0) {
          this.setState({
            hits: [],
            displayLoader: true,
            prioritySlotsPremiumExhibitors: []
          });
        }
        if (Utils.isDiscoverEnabled(context.eventEditionId)) {
          const discoverConfiguration = Utils.getDiscoverConfig();
          const discoverEventId = discoverConfiguration.events.find(e => e.eventEditionId === context.eventEditionId).discoverEventId
          const discoverFilters = DiscoverService.convertToDiscoverFilters(this.state.filterQuery);
          this.setState({ discoverFilters: discoverFilters });
          DiscoverService
            .searchDiscoverProducts(context.interfaceLocale, discoverConfiguration.discoverSearchUrl, query, discoverFilters, discoverEventId)
            .then((response) => {
              this.setState({
                discoverProducts: response.results,
                discoverTotal: response.total
              })
            });
        }

        const filterData = await this.fetchFilterData();

        if (pageNo === 0 && this.arePremiumSlotsEnabled()) {
          await this.loadPremiumExhibitorsInPrioritySlot(request, filterData);
        }

        const result = await algoliaService.getAlgoliaData(algoliaConfig, indexName, request, filterData, this.state.prioritySlotsPremiumExhibitors)
        result.err != null
          ? this.setState({
            hasMore: false,
            hasError: result.err.statusCode === 400 || result.err.statusCode === 404
          })
          : this.handleResponse(result.content);
      })
    }
    catch (error) {
      if (error.message === 'request for lock canceled') {     //will be suppressed. because this will produce a lot of logs in case of multiple requests.
        // (i.e. on multiple user clicks, previous side effects will be cancelled)
        return;
      }
      logger.logWarnWithEvent('Error while fetching AlgoliaData', error.stack, { 'eventEditionId': context.eventEditionId });
      this.setState({
        hasError: true
      });
    }
  };

  loadPremiumExhibitorsInPrioritySlot = async (request, filterData) => {
    const { appId, apiKey } = this.props;
    const { indexName } = this.state;
    const algoliaConfig = {
      appId,
      apiKey
    };

    const goldPremiumExhibitorIds = algoliaService.getPremiumExhibitorIdsFromAlgolia(algoliaConfig, indexName, request, filterData, Packages.gold);

    const silverPremiumExhibitorIds = algoliaService.getPremiumExhibitorIdsFromAlgolia(algoliaConfig, indexName, request, filterData, Packages.silver);

    await Promise.all([goldPremiumExhibitorIds, silverPremiumExhibitorIds]).then(async (responses) => {
      if (responses[0].err != null || responses[1].err != null)
        this.setState({ hasMore: false, hasError: responses.err.statusCode === 400 || responses.err.statusCode === 404 });
      else {
        await this.handlePremiumExhibitorsResponse(responses[0].hits, responses[1].hits, filterData);
      }
    });
  }

  getSortedQuestions = (countryQuestion, sectorFilters, venueFilters, ppsQuestions) => {
    if (venueFilters) {
      ppsQuestions = ppsQuestions.concat([venueFilters]);
    }
    if (sectorFilters) {
      ppsQuestions = ppsQuestions.concat([sectorFilters]);
    }
    if (countryQuestion) {
      ppsQuestions = ppsQuestions.concat([countryQuestion]);
    }
    return ppsQuestions;
  };

  mapFilterData = (filterData) => {
    if (this.isExhibitorDirectory()) {
      const { nestedKey } = this.state
      filterData.forEach(data => {
        data[nestedKey].forEach(filter => {
          if (filter.queryKey === 'features')
            filter.queryKey = 'exhibitorFeatures';
        })
      })
    }
    else if (this.isProductDirectory()) {
      const { nestedKey } = this.state
      filterData.forEach(data => {
        data[nestedKey].forEach(filter => {
          if (filter.queryKey === 'features')
            filter.queryKey = 'productFeatures';
        })
      })
    }
    return filterData;
  }

  fetchFilterData = async () => {
    const {
      appId, apiKey, context
    } = this.props;
    const { indexName } = this.state;
    const algoliaConfig = {
      appId,
      apiKey
    };
    this.setState({ hasMore: false });
    try {
      const result = await algoliaService.getFilterData(algoliaConfig, indexName, this.getRecordTypeAndLocaleFilter());
      const data = this.parseFilterData(
        context.interfaceLocale, this.isExhibitorDirectory(),
        this.state.networkFollowees, this.showNetworkingFacet(context), context.eventEditionId, result.facets
      );
      const filterData = parseFilterJson(data, this.state);
      const sortedPPS = sortBy(filterData, [PPSSortOrder]);
      const ppsQuestions = [];
      let countryQuestion;
      let sectorFilters;
      let venueFilters;
      sortedPPS.forEach((filteData) => {
        const question = filteData.text;
        if (question === CountryFilters) {
          countryQuestion = filteData;
        } else if (filteData.facetKey === this.getVenueFilterKey()) {
          venueFilters = filteData;
        } else if (filteData.facetKey === this.getSectorFilterKey()) {
          sectorFilters = filteData;
        } else {
          ppsQuestions.push(filteData);
        }
      });

      const dataWithLabels = populateLabel(this.getSortedQuestions(countryQuestion, sectorFilters, venueFilters, ppsQuestions), this.state);
      const selectedValues = window.location.search ? refineFiltersFromQueryString(window.location.search.slice(1), result.facets) : [];
      return markSelectedItems(dataWithLabels, [].concat(...selectedValues));
    } catch (error) {
      Logger.logWarnWithEvent('Error while fetching FilterData', error.stack, { indexName });
      this.setState({
        hasError: true
      });
      return [];
    }
  };

  handleResponse = (response) => {
    const { hits } = response;
    let updatedHits;
    let total;
    let hasMore;
    if (this.arePremiumSlotsEnabled()) {
      if (!this.state.searchState.query && !this.state.filterQuery?.length > 0) {
        updatedHits = this.state.hits.concat(hits);
        total = response.nbHits;
      }
      else {
        updatedHits = uniqBy(this.state.hits.concat(hits), 'id');
        total = this.state.prioritySlotsPremiumExhibitors.length + response.nbHits;
      }
      hasMore = (response.page + 1) < response.nbPages;
    }
    else {
      updatedHits = uniqBy(this.state.hits.concat(hits), 'id');
      total = response.nbHits;
      hasMore = updatedHits.length < response.nbHits;
    }

    if (response.nbPages <= response.page && parseInt(getQueryParamValue(paginationQueryParam))) {
      this.setState({
        hasMore,
        resetPage: Utils.generateRandomNumber(),
        pageStart: response.nbPages - 1
      });
      window.history.replaceState(
        {},
        null,
        `${window.location.pathname}?${qs.stringify(constructQueryParamWithExistingQueryParams(
          'page',
          response.nbPages, this.GetUrlParamsExceptSEOPageParam()
        ))}`
      );
      this.loadItems(response.nbPages - 1);
      return;
    }
    this.setState({
      hasMore,
      hits: updatedHits,
      total,
      hasError: false,
      displayLoader: false
    });
  };

  getRandomisedPremiumExhibitors = (premiumExhibitors, quantity) => {
    if (quantity <= 0)
      return [];
    const filteredPremiumExhibitors = premiumExhibitors.filter((product) => !product.video?.id || (product.video?.id && product.video?.status === 'Successful'));
    if (filteredPremiumExhibitors.length <= quantity)
      return filteredPremiumExhibitors.map(x => x.objectID);

    const indexResult = [];
    while (indexResult.length < quantity) {
      const randomIndex = Math.floor(Utils.generateRandomNumber() * filteredPremiumExhibitors.length);
      if (!indexResult.includes(randomIndex))
        indexResult.push(randomIndex)
    }

    return indexResult.map(x => filteredPremiumExhibitors[x].objectID);
  }

  handlePremiumExhibitorsResponse = async (goldExhibitorsResponse, silverExhibitorsResponse, filterData) => {
    if (goldExhibitorsResponse.length <= 0 && silverExhibitorsResponse.length <= 0) {
      return;
    }

    const noOfGoldSlotsAllocated = getNoOfSlotsAllocated(Packages.gold);
    const noOfSilverSlotsAllocated = getNoOfSlotsAllocated(Packages.silver);
    const prioritySlotsAllocated = {
      'gold': noOfGoldSlotsAllocated,
      'silver': noOfSilverSlotsAllocated
    }
    const algoliaConfig = {
      appId: this.props.appId,
      apiKey: this.props.apiKey
    };

    let prioritySlotsExhibitors;
    if (this.state.filterQuery?.length === 0) {
      const randomisedGoldExhibitors = this.getRandomisedPremiumExhibitors(goldExhibitorsResponse, noOfGoldSlotsAllocated);
      const randomisedSilverExhibitors = this.getRandomisedPremiumExhibitors(silverExhibitorsResponse, noOfSilverSlotsAllocated);
      prioritySlotsExhibitors = randomisedGoldExhibitors.concat(randomisedSilverExhibitors);
      this.setState({ prioritySlotsPremiumExhibitors: prioritySlotsExhibitors });
      if (prioritySlotsExhibitors.length === 0) {
        return;
      }
      await algoliaService.getAlgoliaDataByIds(algoliaConfig, this.state.indexName, prioritySlotsExhibitors, this.state.searchState.query)
        .then((result) => {
          if (result.err != null)
            this.setState({ hasMore: false, hasError: result.err.statusCode === 400 || result.err.statusCode === 404 });
          else {
            let goldResponse = [], silverResponse = [];
            result.content.hits.forEach((x) => {
              x.isPrioritySlotPremiumExhibitor = true;
              if (x.packageId === Packages.gold) {
                goldResponse.push(x);
              }
              else if (x.packageId === Packages.silver) {
                silverResponse.push(x);
              }
            });

            this.setState({
              hits: goldResponse.concat(silverResponse),
              total: result.content.nbHits,
              hasError: false
            });
          }
        });
    }
    else {
      const selectedSponsoredCategoryIds = algoliaService.sponsoredCategoryFilterArray(this.state.filterQuery, filterData).map(x => x.split(':')[1]);
      prioritySlotsExhibitors = this.getPrioritySlotsPremiumExhibitors(selectedSponsoredCategoryIds, goldExhibitorsResponse, silverExhibitorsResponse, prioritySlotsAllocated);
      this.setState({ prioritySlotsPremiumExhibitors: prioritySlotsExhibitors });
      if (prioritySlotsExhibitors.length === 0) {
        return;
      }
      await algoliaService.getAlgoliaDataByIds(algoliaConfig, this.state.indexName, prioritySlotsExhibitors, this.state.searchState.query)
        .then((result) => {
          if (result.err != null)
            this.setState({ hasMore: false, hasError: result.err.statusCode === 400 || result.err.statusCode === 404 });
          else {
            let goldSponsoredResponse = [], goldNonSponsoredResponse = [], silverResponse = [];
            result.content.hits.forEach((x) => {
              x.isPrioritySlotPremiumExhibitor = true;
              if (x.packageId === Packages.gold) {
                if (x.sponsoredCategory && selectedSponsoredCategoryIds.includes(x.sponsoredCategory.id)) {
                  goldSponsoredResponse.push(x);
                }
                else {
                  goldNonSponsoredResponse.push(x);
                }
              }
              else if (x.packageId === Packages.silver) {
                silverResponse.push(x);
              }
            });

            this.setState({
              hits: goldSponsoredResponse.concat(goldNonSponsoredResponse).concat(silverResponse),
              total: result.content.nbHits,
              hasError: false
            });
          }
        });
    }
  };

  getPrioritySlotsPremiumExhibitors = (selectedSponsoredCategoryIds, goldExhibitorsResponse, silverExhibitorsResponse, prioritySlotsAllocated) => {
    let goldSponsoredExhibitors = [], goldExhibitorsWithoutSponsor = [];

    goldExhibitorsResponse.forEach(x =>
      x.sponsoredCategory && selectedSponsoredCategoryIds.includes(x.sponsoredCategory.id)
        ? goldSponsoredExhibitors.push(x.objectID) : goldExhibitorsWithoutSponsor.push(x));

    const goldSponsoredExhibitorsCount = goldSponsoredExhibitors.length;
    const totalNoOfPrioritySlots = prioritySlotsAllocated.gold + prioritySlotsAllocated.silver;

    if (goldSponsoredExhibitorsCount >= totalNoOfPrioritySlots) {
      return goldSponsoredExhibitors.slice(0, totalNoOfPrioritySlots);
    }

    const prioritySlots = this.getNoOfPrioritySlotsForPremiumExhibitors(goldSponsoredExhibitorsCount, prioritySlotsAllocated);
    const randomisedGoldExhibitors = this.getRandomisedPremiumExhibitors(goldExhibitorsWithoutSponsor, prioritySlots.priorityGoldSlotsRemaining);
    const randomisedSilverExhibitors = this.getRandomisedPremiumExhibitors(silverExhibitorsResponse, prioritySlots.prioritySilverSlotsRemaining);
    return goldSponsoredExhibitors.concat(randomisedGoldExhibitors).concat(randomisedSilverExhibitors);
  }

  getNoOfPrioritySlotsForPremiumExhibitors = (goldSponsoredExhibitorsCount, prioritySlotsAllocated) => {
    let priorityGoldSlotsRemaining = 0, prioritySilverSlotsRemaining = 0;

    if (goldSponsoredExhibitorsCount >= prioritySlotsAllocated.gold) {
      prioritySilverSlotsRemaining = prioritySlotsAllocated.silver - (goldSponsoredExhibitorsCount - prioritySlotsAllocated.gold);
    }
    else {
      priorityGoldSlotsRemaining = prioritySlotsAllocated.gold - goldSponsoredExhibitorsCount;
      prioritySilverSlotsRemaining = prioritySlotsAllocated.silver;
    }
    return { priorityGoldSlotsRemaining, prioritySilverSlotsRemaining };
  }

  createProductsComponent = (hits, discoverProducts, discoverTotal) => {
    const {
      navigation, context, testVariants, baseApiUrl
    } = this.props;
    const props = {
      translations: this.getTranslations(context),
      defaultOrganisationListingLogoUrl,
      exhibitorPublicDetailsUrlFormat: navigation.exhibitorPublicDetailsUrlFormat,
      productDetailsUrlFormat: navigation.productDetailsUrlFormat,
      testVariants,
      showPlanningEnabled: context.showPlanningEnabled,
      interfaceLocale: context.interfaceLocale,
      eventEditionId: context.eventEditionId,
      products: AlgoliaMapper.mapProducts(hits),
      baseApiUrl
    };

    if (Utils.isDiscoverEnabled(context.eventEditionId)) {
      return <React.Fragment>
        <DiscoverProducts {...props} products={discoverProducts} total={discoverTotal}
          query={this.state.searchState.query} filters={this.state.discoverFilters} />
        <Products {...props} products={props.products} />
      </React.Fragment>;
    }
    return React.createFactory(Products)(props);
  }

  createProducerComponent = (artists) => {
    const {
      navigation, context, testVariants
    } = this.props;
    const props = {
      translations: this.getTranslations(context),
      defaultArtistLogoUrl,
      exhibitorPublicDetailsUrlFormat: navigation.exhibitorPublicDetailsUrlFormat,
      artistDetailsUrlFormat: navigation.artistDetailsUrlFormat,
      testVariants,
      showPlanningEnabled: context.showPlanningEnabled,
      artists
    };
    return React.createFactory(Producer)(props);
  }

  getTranslations = context => TranslationService.getTranslations(context.interfaceLocale);

  isExhibitorDirectory = () => {
    return this.props.directoryPage === 'exhibitor'
  }

  isProductDirectory = () => {
    return this.props.directoryPage === 'product'
  }

  isArtist = () => {
    const { indexName } = this.props;
    return indexName.startsWith('artist');
  }


  getDtmPrefix = () => {
    if (this.isExhibitorDirectory()) {
      return 'exhibitorDirectory';
    }

    if (this.isArtist()) {
      return 'producerDirectory';
    }

    return 'productDirectory';
  };

  getDtmTags = () => {
    if (this.isExhibitorDirectory()) {
      return Tags.exhibitorDirectory;
    }

    if (this.isArtist()) {
      return Tags.producerDirectory;
    }

    return Tags.productDirectory;
  };


  getTotalRecordsConfig = () => {
    const {
      context
    } = this.props;

    const translation = this.getTranslations(context);

    const directoryTranslation = () => {
      if (this.isExhibitorDirectory()) {
        return translation.directory.exhibitors;
      }

      if (this.isArtist()) {
        return translation.artistDirectory.artists;
      }

      return translation.productDirectory.products;
    };

    const getSearchPrefixes = () => {
      if (this.isExhibitorDirectory()) {
        return translation.directory.search.prefix;
      }

      if (this.isArtist()) {
        return translation.artistDirectory.search.prefix;
      }

      return translation.productDirectory.search.prefix;
    };

    const searchPrefixes = getSearchPrefixes();
    const isNetworkingShow = Utils.getFromSessionStorage('isParticipationEvent');

    return {
      total: this.state.total || 0,
      suffix: directoryTranslation(),
      prefix: {
        mobileFilterContracted: searchPrefixes.mobileFilterContracted,
        showing: (this.isExhibitorDirectory() && isNetworkingShow) ? searchPrefixes.desktopNetworking : searchPrefixes.desktop
      }
    };
  };

  getSearchConfig = () => {
    const {
      context, directoryPage
    } = this.props;
    const translation = this.getTranslations(context);
    const isNetworkingShow = Utils.getFromSessionStorage('isParticipationEvent');
    let searchBarPLaceholder = '';
    if (directoryPage === 'exhibitor') {
      searchBarPLaceholder = isNetworkingShow ? translation.directory.search.placeholderNetworking : translation.directory.search.placeholder;
    } else if (directoryPage === 'product') {
      searchBarPLaceholder = translation.productDirectory.search.placeholder;
    } else if (directoryPage === 'artist') {
      searchBarPLaceholder = translation.artistDirectory.search.placeholder;
    }
    return {
      searchBarPlaceHolder: searchBarPLaceholder,
      resetText: translation.directory.filters.reset,
      appliedFilterText: translation.directory.filters.filterApplied
    };
  }

  parseFilterData = (interfaceLocale, isExhibitor, networkFollowees, showNetworkingFacet, eventEditionId, facets = {}) => {
    let flatFilterPrefix;
    if (this.isExhibitorDirectory())
      flatFilterPrefix = [Filters.ExhibitorFeaturesKey, this.getProductAndServicesFilterKey(), this.getSectorFilterKey(), this.getVenueFilterKey()];
    else if (this.isProductDirectory())
      flatFilterPrefix = [Filters.ProductFeaturesKey, this.getProductAndServicesFilterKey(), this.getSectorFilterKey(), this.getVenueFilterKey()];
    else
      flatFilterPrefix = [Filters.FeaturesKey, this.getProductAndServicesFilterKey(), this.getSectorFilterKey(), this.getVenueFilterKey()];

    const filterItemTags = isExhibitor ? Tags.exhibitorDirectory.filterItem : Tags.productDirectory.filterItem;
    const translation = TranslationService.getTranslations(interfaceLocale);
    let filterData = [];
    if (showNetworkingFacet &&
      Object.keys(facets).includes(OrganisationGuidFacet.organisationGuid)) {
      flatFilterPrefix.push(OrganisationGuidFacet.organisationGuid);
      const finalNetworkingOrganisations = networkFollowees.reduce((a, key) => Object.assign(a, { [key]: 1 }), {});
      facets.organisationGuid = finalNetworkingOrganisations;
    }
    const flatFilters = Object.keys(facets).filter(facet => flatFilterPrefix.some(fp => facet.startsWith(fp)));
    let filterDataSet = [];
    const directoryTranslations = isExhibitor ? translation.directory : translation.productDirectory;

    flatFilters.forEach((flatFilter) => {
      let attr = this.getFlatFacetAttributes().includes(flatFilter) ? flatFilter.split('.')[1] : flatFilter;
      if (flatFilter === Filters.ExhibitorFeaturesKey || flatFilter === Filters.ProductFeaturesKey)
        attr = Filters.FeaturesKey;
      filterDataSet.push(Object.assign({
        text: (showNetworkingFacet && attr === OrganisationGuidFacet.organisationGuid) ?
          directoryTranslations.filters[OrganisationGuidFacet.networking]
          : directoryTranslations.filters[attr],
        facetKey: flatFilter,
        sortOrder: -1,
        answers: Object.keys(facets[flatFilter]).map(x =>
          Object.assign({
            text: directoryTranslations.filters[sanitizeLabel(x)] || sanitizeLabel(x),
            queryText: x,
            queryKey: flatFilter,
            answers: [],
            dtmTag: filterItemTags[attr] ? filterItemTags[attr][x] || filterItemTags[attr].default : '',
            count: facets[flatFilter][x]
          }))
      }));
    });


    const ppsFilterKeys = Object.keys(facets).filter(facet => facet.startsWith(this.getFilterKey()) && !flatFilterPrefix.includes(facet));
    let levelKeys = uniqBy(ppsFilterKeys.map((i) => {
      const c = i.split('.');
      return c[c.length - 1];
    }));
    levelKeys = levelKeys.filter(levelKey => levelKey !== PPSSortOrder);
    filterData = groupBy(ppsFilterKeys, facet => {
      // 8 -> length of 'filters.' Ex: filers.question.test..lvl0 -> question.test.
      if (facet.lastIndexOf('.') === facet.indexOf('.')) {
        return facet.indexOf('.') === -1 ? '' : facet.split('.')[1]
      }
      return facet.substring((this.getFilterKey() + '.').length, facet.lastIndexOf('.'))
    });
    const questions = Object.keys(filterData).filter(f => f !== '');
    if (levelKeys.length > 0) {
      questions.forEach((question) => {
        const translatedQuestionText = directoryTranslations.filters[question];
        const parsedQuestion = parseQuestion(question, filterData, facets, 0, levelKeys, translatedQuestionText, this.getFilterKey());
        if (parsedQuestion.answers && parsedQuestion.answers.length !== 0) {
          filterDataSet.push(parsedQuestion);
        } else {
          Logger.logWarnWithEvent('PPS Question has invalid answers', '', {
            eventEditionId, question
          })
        }
      });
    } else if (questions.length > 0) {
      Logger.logWarnWithEvent('All PPS Questions has invalid answers', '', { eventEditionId })
    }
    return filterDataSet;
  };

  getFilterKey = () => {
    if (this.isExhibitorDirectory()) {
      return Filters.ExhibitorFiltersKey;
    }
    else if (this.isProductDirectory()) {
      return Filters.ProductFiltersKey;
    }
    else {
      return Filters.FiltersKey;
    }
  }

  getProductAndServicesFilterKey = () => {
    return this.getFilterKey() + Filters.ProductAndServicesFilterKeySuffix;
  }

  getSectorFilterKey = () => {
    return this.getFilterKey() + Filters.SectorFilterKeySuffix;
  }

  getVenueFilterKey = () => {
    return this.getFilterKey() + Filters.VenueFilterKeySuffix;
  }

  getFlatFacetAttributes = () => {
    return [this.getProductAndServicesFilterKey(), this.getSectorFilterKey(), this.getVenueFilterKey()];
  }

  reRenderNetworkFollowees = (organisationId, isFollowed) => {
    if (isFollowed) {
      this.setState({
        networkFollowees: [...this.state.networkFollowees, organisationId]
      });
    } else {
      this.setState({
        networkFollowees: this.state.networkFollowees.filter(item => item !== organisationId)
      });
    }
  }

  renderExhibitorDirectory =
    (hits, context, testVariants, showPlan, baseApiUrl, navigation, networkFollowees, digitalPortfolioId, isNetworkParticipant, userId, hideStandInfo, showExhibitorRecommendation) =>
    (context.exhibitorDirectoryView && context.exhibitorDirectoryView === 'grid' ?
      <ExhibitorDirectoryGridView
        exhibitors={AlgoliaMapper.mapExhibitors(hits)}
        navigation={navigation}
        context={context}
        hideStandInfo={hideStandInfo}
      /> : <ExhibitorDirectoryListView
        exhibitors={AlgoliaMapper.mapExhibitors(hits)}
        navigation={navigation}
        context={context}
        testVariants={testVariants}
        showPlan={showPlan}
        baseApiUrl={baseApiUrl}
        networkFollowees={networkFollowees}
        digitalPortfolioId={digitalPortfolioId}
        isNetworkParticipant={isNetworkParticipant}
        handleFollowClick={(organisationId, isFollowed) => {
          this.reRenderNetworkFollowees(organisationId, isFollowed);
        }}
        userId={userId}
        hideStandInfo={hideStandInfo}
        showExhibitorRecommendation={showExhibitorRecommendation}
      />)

  renderSearchResult = () => {
    const {
      hits, networkFollowees, digitalPortfolioId, isNetworkParticipant, userId,
      discoverProducts, discoverTotal, hideStandInfo, showExhibitorRecommendation
    } = this.state;
    const {
      testVariants, showPlan, baseApiUrl, navigation
    } = this.props;
    const context = { ...this.props.context, isMercuryParticipantShow: this.state.isMercuryParticipantShow }

    if (this.isExhibitorDirectory()) {
      return this.renderExhibitorDirectory(
        hits, context, testVariants, showPlan, baseApiUrl,
        navigation, networkFollowees, digitalPortfolioId, isNetworkParticipant, userId, hideStandInfo, showExhibitorRecommendation
      );
    }

    if (this.isArtist()) {
      return this.createProducerComponent(hits);
    }

    return this.createProductsComponent(hits, discoverProducts, discoverTotal);
  }

  seoLinks = () => {
    const page = parseInt(getQueryParamValue(paginationQueryParam));
    if (!page) {
      return (
        this.state.hasMore ?
          <a
            rel='next'
            aria-label='Next page SEO link'
            href={`${window.location.pathname}?${appendQueryParam(paginationQueryParam, 2)}`}
          >
           <span aria-hidden='true' /> {/* Added this to satisfy warning of 'Anchors mush have content' */}
          </a>
          : null
      )
    }
    return (
      <>
        {page === 2 ?
          <a
            rel='prev'
            aria-label='Previous page SEO link'
            href={`${window.location.pathname}?${removeQueryParam(paginationQueryParam)}`}
          >
            <span aria-hidden='true' /> {/* Added this to satisfy warning of 'Anchors mush have content' */}
          </a>
          : null}
        {page > 2 ?
          <a
            rel='prev'
            aria-label='Previous page SEO link'
            href={`${window.location.pathname}?${appendQueryParam(paginationQueryParam, page - 1)}`}
          >
            <span aria-hidden='true' /> {/* Added this to satisfy warning of 'Anchors mush have content' */}
          </a>
          : null}
        {this.state.hasMore ?
          <a
            rel='next'
            aria-label='Next page SEO link'
            href={`${window.location.pathname}?${appendQueryParam(paginationQueryParam, page + 1)}`}
          >
            <span aria-hidden='true' /> {/* Added this to satisfy warning of 'Anchors mush have content' */}
          </a>
          : null}
      </>)
  }

  // eslint-disable-next-line react/sort-comp
  render() {
    const { hasError, displayLoader } = this.state;
    const { context, pageTitle } = this.props;
    const translation = this.getTranslations(context);
    return hasError ? (
      <ErrorContainer errors={[translation.errorMessages.exhibitor_directory_failed_to_load]} />
    ) : (
      <>
        {this.seoLinks()}
        <CustomSearch.CustomAlgoliaComponent
          {...this.props}
          {...this.state}
          dtmPrefix={this.getDtmPrefix()}
          onFilterUpdate={this.onFilterUpdate}
          fetchFilterData={this.fetchFilterData}
          loadItems={this.loadItems}
          onSearch={this.onSearch}
          sortOnChange={this.sortOnChange}
          dtmTags={this.getDtmTags()}
          facets={translation.facets}
          pageTitle={pageTitle}
          filterTitle={translation.directory.filterTitle}
          totalRecordsConfig={this.getTotalRecordsConfig()}
          searchConfig={this.getSearchConfig()}
          sortTitle={translation.productDirectory.sortTitle}
          sortDoneText={translation.productDirectory.sortDoneText}
          disableDefaultSorting
          facetToBeExcluded={this.showNetworkingFacet(context) ?
            translation.directory.filters.networking : undefined}
          maskedName={this.showNetworkingFacet(context) ?
            translation.directory.filters.companiesIFollow : undefined}
          logger={logger}
        >
          {displayLoader ? <BigCircleSpinner /> : <> {this.renderSearchResult()} </>}
        </CustomSearch.CustomAlgoliaComponent>
      </>
    );
  }
}

AlgoliaWrapper.propTypes = {
  eventEditionId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
  indexName: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  navigation: PropTypes.object.isRequired,
  context: PropTypes.shape({
    eventEditionId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired,
    showPlanningEnabled: PropTypes.bool,
    mode: PropTypes.string,
    tenants: PropTypes.string
  }).isRequired,
  assets: PropTypes.object.isRequired,
  testVariants: PropTypes.arrayOf(PropTypes.string),
  showPlan: PropTypes.object.isRequired,
  showPlanningEnabled: PropTypes.bool,
  baseApiUrl: PropTypes.string.isRequired,
  pageTitle: PropTypes.string,
  directoryPage: PropTypes.oneOf(['exhibitor', 'product', 'artist']).isRequired
};

export default AlgoliaWrapper;
